//////////////////////////////////////////////////////////////
//     							                                        //
//  Program: MasterHouseRuleService.js                      //
//  Application: MasterHouseRuleService                     //
//  Option: Used to manage the Master House Rules catalog   //
//  Date: 2026-07-09                                        //
//                                                          //
//////////////////////////////////////////////////////////////

import ApiService from "./ApiService";

class MasterHouseRuleService {
  getMasterHouseRule() {
    let endPoint = "master-house-rule";
    let addditionalHeaderData = {};
    let postData = {};

    let inputData = {
      endPoint: endPoint,
      addditionalHeaderData: addditionalHeaderData,
      postData: postData,
    };
    let response = ApiService.getCall(inputData);
    return response;
  }

  createMasterHouseRule(data) {
    // Delete data which we don't want to send
    delete data.errors;
    delete data.input;

    let endPoint = "master-house-rule";
    let addditionalHeaderData = {};
    let postData = data;

    let inputData = {
      endPoint: endPoint,
      addditionalHeaderData: addditionalHeaderData,
      postData: postData,
    };
    let response = ApiService.postCall(inputData);
    return response;
  }

  getMasterHouseRuleBySlug(slug) {
    let endPoint = "master-house-rule/" + slug;
    let addditionalHeaderData = {};
    let postData = {};

    let inputData = {
      endPoint: endPoint,
      addditionalHeaderData: addditionalHeaderData,
      postData: postData,
    };
    let response = ApiService.getCall(inputData);
    return response;
  }

  updateMasterHouseRule(slug, data) {
    // Delete data which we don't want to send
    delete data.errors;
    delete data.input;

    let endPoint = "master-house-rule/" + slug;
    let addditionalHeaderData = {};
    let postData = data;

    let inputData = {
      endPoint: endPoint,
      addditionalHeaderData: addditionalHeaderData,
      postData: postData,
    };
    let response = ApiService.putCall(inputData);
    return response;
  }
}

export default new MasterHouseRuleService();
